<template>
  <v-container ref="copyContainer" grid-list-xl fluid>
    <v-layout row wrap>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="!pageLoading">
        <filter-order-pricing
          :default-search-params="searchParams"
          :is-component-loading="isRequestingNow"
          @filtering="onFilter"
        ></filter-order-pricing>
        <table-paginated-order-pricing
          :is-component-loading="isRequestingNow"
          :paginated-object="paginatedObject"
          @delete-item="onPaginatedItemDelete"
        ></table-paginated-order-pricing>
        <pagination-listing
          :pagination-data="paginationData"
          @go-prev="changePage('-')"
          @go-next="changePage('+')"
        ></pagination-listing>
      </v-flex>
      <modal-loading :is-show="isTableLoading"></modal-loading>
    </v-layout>
  </v-container>
</template>

<script>
/* constants */
import { PER_PAGE } from '@/constants/listing';
import { ORDER_PRICING_CONTROL_USERS } from '~api/order_pricing_control_access';

/* utils */
import { router } from '@/plugins/vue-router';

/* proxy */
import OrderPricingProxy from '@/proxies/OrderPricing/OrderPricingProxy';

/* mixins */
import updatePageContentMixin from '../../mixins/updatePageContentMixin';
import paginationMixin from '../../mixins/listing/paginationMixin';
import defaultListingMixin from '../../mixins/listing/defaultListingMixin';

/* components */
import PaginationListing from '@/components/listings/PaginationListing.vue';
import ModalLoading from '@/components/loaders/ModalLoading.vue';
import TablePaginatedOrderPricing from '@/components/listings/TablePaginatedOrderPricing.vue';
import FilterOrderPricing from '@/components/listings/FilterOrderPricing.vue';

export default {
  name: 'Listing',
  mixins: [
    paginationMixin,
    defaultListingMixin,
    updatePageContentMixin,
  ],
  components: {
    PaginationListing,
    ModalLoading,
    TablePaginatedOrderPricing,
    FilterOrderPricing,
  },
  data() {
    return {
      /* Page management */
      pageLoading: false,
      /* Create - Edit */
      currentEditableItem: {},
      /* Delete */
      isShowDeleteDialog: false,
      /* Listing management */
      isTableLoading: false,
      searchParams: {
        page: {
          number: 1,
          size: PER_PAGE,
        },
        region: null,
      },
    };
  },
  created() {
    if (!ORDER_PRICING_CONTROL_USERS.includes(this.account.phone)) {
      router.push({ name: 'home.default' });
      return;
    }

    this.isTableLoading = true;
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
    /* edit modal */
    orderDialogActionLabel() {
      if (this.isShowOrderDialog) {
        return (this.currentEditableItem.uuid)
          ? this.lang(this.$store, 'sap/listings.global.edit.save')
          : this.lang(this.$store, 'sap/listings.global.edit.create');
      }
      return '';
    },
  },
  methods: {
    fetchData() {
      this.isRequestingNow = true;
      new OrderPricingProxy()
        .setParameters(this.searchParams)
        .all()
        .then((response) => {
          this.paginatedObject = response.data.data.pricing;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.warn(error);
          this.paginatedObject = {};
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },

    onAcceptDeletion() {
    },
    onPaginatedItemDelete(item) {
    },
  },
};

</script>

<style scoped>

</style>
